<template>
	<SectionComponent :sectionData="sectionData" :mainSettings="mainSettings" :debugData="debugData"
		:labelPreview="labelPreview" />
</template>

<script>
import SectionComponent from './SectionComponent.vue';

export default {
	components: {
		SectionComponent
	},

	props: {
		sectionData: {
			type: Object
		},
		mainSettings: {
			type: Object
		},
		debugData: {
			type: Object
		},
		labelPreview: {
			type: Array
		}
	},
}
</script>

<style lang="scss">
@import '@/assets/scss/design-aachen/_imports.scss';
</style>